export function normalizeSearchText(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\u00e7/gi, 'c')
    .replace(/\u00f1/gi, 'n')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');
}

export function matchesSearchText(haystack: string, query: string): boolean {
  const normalizedQuery = normalizeSearchText(query);

  if (!normalizedQuery) {
    return true;
  }

  return normalizeSearchText(haystack).includes(normalizedQuery);
}
